import banners from "./tooltip-images/banners.png"
import categories from "./tooltip-images/categories.png"
import games_grid from "./tooltip-images/games_grid.png"
import games_row from "./tooltip-images/games_row.png"
import highlight_game from "./tooltip-images/highlight_game.png"
import information from "./tooltip-images/information.png"
import last_wins from "./tooltip-images/last_wins.png"
import profile from "./tooltip-images/profile.png"
import providers_slider from "./tooltip-images/providers_slider.png"
import random_game from "./tooltip-images/random_game.png"

const tooltipImages = {
  banners,
  categories,
  games_grid,
  games_row,
  highlight_game,
  information,
  last_wins,
  profile,
  providers_slider,
  random_game,
  text: information,
  profile_button: profile,
}

export { tooltipImages }
